import {
  Component,
  Input,
  Self,
  Optional,
  EventEmitter,
  Output,
  ViewChild,
  HostListener,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { UserPersonSharedService } from 'src/app/services/shared/user/person/sharedPerson.service';
import * as moment from 'moment';

@Component({
  selector: 'apc-form-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  host: { class: 'apc-form-select' },
})
export class SelectComponent implements ControlValueAccessor,OnChanges {
  @Input() loading: boolean = false;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() class: string;
  @Input() items: any;
  @Input() optionName: any = 'name';
  @Input() optionValue: any = 'identifier';
  @Input() optionDescription: Array<string>;
  @Input() placeholder: any;
  @Input() rows: string;
  @Input() onEdit: boolean;
  @Input() appendTo: string | null = null;
  @Input() isObject: boolean = false;
  @Input() valueDescription: boolean = false;
  @Input() autogenerated: boolean = false;
  @Input() showAdditional: string | null = null;
  @Output() isChanged = new EventEmitter<any>();
  @Output() isOpen = new EventEmitter<any>();

  @Input() enableType: string | null = null;
  @Input() iconType: string | null = null;
  @Input() setSelect: Function;
  @Input() sec: string;
  @Input() subSec: string;
  @Input() pertinence: string;
  @Input() managerSelect: boolean = false;
  @Input() showHeaderSelect: boolean = true;
  @Input() isRequired: boolean = false;
  @Input() renderValue: string = '';

  @ViewChild('select') select;
  @ViewChild('input') input;


  @ViewChild('t') t: NgbTooltip;

  value: any = null;
  
  public currentType: string = 'select';
  public checkPermission:any;
  public routerLink: string;
  public newValueSelected:string;
  constructor(
    @Self() @Optional() public ngControl: NgControl, 
    private cdRef: ChangeDetectorRef, 
    private userPersonSharedService: UserPersonSharedService) {
    this.ngControl && (this.ngControl.valueAccessor = this);
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;   
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if(changes.disabled){
      this.disabled = changes.disabled.currentValue;
    }
  }


  @HostListener('click', ['$event'])
  onTripleClickOpenEdit(e) {

    this.userPersonSharedService.isArchived$.subscribe(isArchived => {

      if (e.detail === 3 && !isArchived) {
        this.setSelectType();
      }
    });


  }

  setSelectType() {
    this.currentType = 'select';

    this.cdRef.detectChanges();
    if (
      (this.select && this.select.element.closest('.editForm')) ||
      (this.input && this.input.nativeElement.closest('.editForm'))
    ) {
      this.appendExtraFields()
    }
  }

  ngAfterViewInit() {
    this.appendExtraFields();
    if(this.sec && this.subSec){
      this.checkPermission={ 
        pertinence: this.pertinence, 
        section: this.sec, 
        subsection: this.subSec, 
        context: 'metadata', 
        type: 'MANAGER'
      }
    }
  }
  updateRouterLink(){
    this.routerLink="/persona/"+this.value?.identifier+"/profile";
  }

  appendExtraFields() {
    setTimeout(() => {
      this.clearAppendedExtraSearch(false);
      if (this.value && this.showAdditional && this.value[this.showAdditional]) {
        let div: any = document.createElement('div');
        div.classList.add("append-value");
        div.style = 'margin-left: -1.5px;';
        div.innerHTML = ' (' + this.value[this.showAdditional] + ')';
        if (this.currentType == 'select' && this.select && !this.select.element.getElementsByClassName("append-value")[0]) {
          var placeToAppend = this.select.element.getElementsByClassName('ng-value-container')[0];
          placeToAppend.appendChild(div);
        }
        this.renderValue = this.value[this.optionName] + ' (' + this.value[this.showAdditional] + ')';
      }
    }, 10);
  }

  clearAppendedExtraSearch(timeout: boolean) {
    if (timeout) {
      if (this.select && this.select.element && this.select.element.getElementsByClassName("append-value")[0]) {
        setTimeout(() => this.select.element.getElementsByClassName("append-value")[0].remove(), 10);
      }
    } else {
      if (this.select && this.select.element && this.select.element.getElementsByClassName("append-value")[0]) {
        this.select.element.getElementsByClassName("append-value")[0].remove();
      }
    }

  }

  handleSelectInputEdit() {
    if (
      (this.select && this.select.element.closest('.editForm')) ||
      (this.input && this.input.nativeElement.closest('.editForm'))
    ) {
      //this.currentType = 'text';
      this.appendExtraFields()
    } else {
      this.currentType = 'select';
    }
  }
  emitSelect() {
    this.isOpen.emit(true);
  }

  public onChangeFn = (_: any) => { };
  public onTouchedFn = () => { };

  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: any): void {
    this.value = obj;
    if (this.isObject) {
      this.renderValue = this.value ? this.value[this.optionName] : null;
      this.updateRouterLink();
    }
  }

  public onChange() {
    this.onChangeFn(this.value);
    this.isChanged.emit(this.value);
    this.appendExtraFields();
  }

  // work only with date input type
  clearDate() {
    this.value = null;
    this.onChangeFn(this.value);
  }

  showErrorTooltip() {
    this.t?.open();
  }

  // #1352 extend search funcionality by descriptions (if any)
  customSearchFn = (term: string, item: any) => {
    this.clearAppendedExtraSearch(true);
    term = term.toLocaleLowerCase();
    var additionalDescriptionSearch: boolean = false;
    if (this.optionDescription && this.optionDescription.length > 0) {
      this.optionDescription.forEach((desc) => {
        if (item[desc]) {
          additionalDescriptionSearch =
            additionalDescriptionSearch || item[desc].toLocaleLowerCase().indexOf(term) > -1;
        }
      });
    }
    return item[this.optionName].toLocaleLowerCase().indexOf(term) > -1 || additionalDescriptionSearch;
  };

  selectClass(option: any) {
    let dataEnd = option.dateEnd;
    let no_active = (dataEnd != null && (moment(dataEnd).isBefore(moment())));
    let is_active = (dataEnd === null || (moment(dataEnd).isAfter(moment())));
    if(no_active) {
      return 'grey-color'
    } else if(is_active) {
      return 'font-weight-medium-bold'
    }
  }

  upadateDefaultSelect(selected){
    this.value=selected;
  }
}

